import { inject } from "aurelia-framework";
import { HttpClient } from "aurelia-http-client";

@inject(HttpClient)
export class TestimonialFromYTManagerAPI {
  constructor(http) {
    this.http = http;
  }

  create(token, data, successCallback, errorCallback) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json");
    });

    this.http
      .post("api/youtubeManager/testimonialForm/create", data)
      .then((data) => {
        if (data.isSuccess) {
          if (data.response) {
            var json = JSON.parse(data.response);

            if (json.hasOwnProperty("testimonialRequest")) {
              // if (json.hasOwnProperty("account")) {
              //     successCallback(json.user, json.account, is_trial_expired, sub_error);
              // // }
              // else
              successCallback(json.testimonialRequest);
            }

            if (json.hasOwnProperty("error")) errorCallback(json.error);
          } else successCallback();
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  getUserVideoList(
    account_owner_user_id,
    include_removed,
    search,
    page,
    limit,
    sortBy,
    sortDir,
    token,
    successCallback,
    errorCallback
  ) {
    this.http = this.http.configure((x) => {
      x.withHeader("Content-Type", "application/json").withHeader(
        "Authorization",
        token
      );
    });

    var queryString = "?page=" + page;
    queryString += "&limit=" + limit;
    queryString += "&sortBy=" + sortBy;
    queryString += "&sortDir=" + sortDir;
    queryString += "&includeRemoved=" + include_removed;

    if (search) queryString += "&search=" + search;

    this.http
      .get(
        "api/wladmin/testimonialRequest/getList" +
          (account_owner_user_id == null ? "" : "/" + account_owner_user_id) +
          queryString
      )
      .then((data) => {
        if (data.isSuccess) {
          var json = JSON.parse(data.response);

          if (json.hasOwnProperty("testimonialRequests"))
            successCallback(json.testimonialRequests);

          if (json.hasOwnProperty("error")) errorCallback(json.error);
        } else {
          errorCallback(data.statusText);
        }
      });
  }
}
